import Avatar from "@material-ui/core/Avatar"

const CompanyAvatar = props => {
  const { company, ...rest } = props
  const { name, profileImage } = company

  if (!profileImage) {
    return <Avatar {...rest}>{`${name.charAt(0)}`}</Avatar>
  }

  return <Avatar {...rest} alt={name} src={profileImage} />
}

export default CompanyAvatar
